export default {"src":"/_next/static/media/beam.6708f6a7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};